export default "__VITE_ASSET__Cmn0jfat__"